import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=ea60fc22&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea60fc22",
  null
  
)

export default component.exports